import styled from "styled-components";
const SectionSubheadline = styled.h3`
  margin-bottom: 10px;
`;
export default SectionSubheadline;
